import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {RequestService} from '../../request.service';
import {NotificationService} from '../../notification.service';
import {HttpErrorResponse} from '@angular/common/http';
import AjaxSettings = DataTables.AjaxSettings;

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    prefix = 'PRODUCT.MESSAGE.ERROR.';
    langPrefix = 'product/';

    constructor(private translate: TranslateService, private requestService: RequestService, private notificationService: NotificationService) {
    }

    getList(dataTablesParameters: AjaxSettings): Promise<any> {
        return Promise.resolve((() => {
            return this.requestService.postData('api/getProductList', dataTablesParameters, 'post')
                .toPromise()
                .catch((error: HttpErrorResponse | any) => {
                    this.translate.get([this.prefix + 'LABEL', this.prefix + 'DATA.FETCH.LIST'])
                        .subscribe((response: Object) => this.notificationService.basicNoty('ERROR', response[this.prefix + 'DATA.FETCH.LIST'], response[this.prefix + 'LABEL']));
                    return Promise.reject(error);
                });
        })());
    }

    add(form: Object, isUpdate: boolean = false): Promise<any> {
        const message = isUpdate ? 'DATA.UPDATE.RECORD' : 'DATA.INSERT.RECORD';
        return Promise.resolve((() => {
            return this.requestService.postData('api/addProduct', form, 'post')
                .toPromise()
                .catch((error: HttpErrorResponse | any) => {
                    this.translate.get([this.prefix + 'LABEL', this.prefix + message])
                        .subscribe((response: Object) => this.notificationService.basicNoty('ERROR', response[this.prefix + 'LABEL'], response[this.prefix + message]));
                    return Promise.reject(error);
                });
        })());
    }

    update(form: Object): Promise<any> {
        return Promise.resolve((() => {
            return this.requestService.postData('api/updateProduct', form, 'post')
                .toPromise()
                .catch((error: HttpErrorResponse | any) => {
                    this.translate.get([this.prefix + 'LABEL', this.prefix + 'DATA.UPDATE.RECORD'])
                        .subscribe((response: Object) => this.notificationService.basicNoty('ERROR', response[this.prefix + 'DATA.UPDATE.RECORD'], response[this.prefix + 'LABEL']));
                    return Promise.reject(error);
                });
        })());
    }

    view(form: Object): Promise<any> {
        return Promise.resolve((() => {
            return this.requestService.postData('api/getProductByID', form, 'post')
                .toPromise()
                .catch((error: HttpErrorResponse | any) => {
                    this.translate.get([this.prefix + 'LABEL', this.prefix + 'DATA.VIEW.RECORD'])
                        .subscribe((response: Object) => this.notificationService.basicNoty('ERROR', response[this.prefix + 'DATA.VIEW.RECORD'], response[this.prefix + 'LABEL']));
                    return Promise.reject(error);
                });
        })());
    }

    delete(form: Object): Promise<any> {
        return Promise.resolve((() => {
            return this.requestService.postData('api/deleteProduct', form, 'post')
                .toPromise()
                .catch((error: HttpErrorResponse | any) => {
                    this.translate.get([this.prefix + 'LABEL', this.prefix + 'DATA.DELETE.RECORD'])
                        .subscribe((response: Object) => this.notificationService.basicNoty('ERROR', response[this.prefix + 'DATA.DELETE.RECORD'], response[this.prefix + 'LABEL']));
                    return Promise.reject(error);
                });
        })());
    }

    changeStatus(form: Object): Promise<any> {
        return Promise.resolve((() => {
            return this.requestService.postData('api/productUpdateStatus', form, 'post')
                .toPromise()
                .catch((error: HttpErrorResponse | any) => {
                    this.translate.get([this.prefix + 'LABEL', this.prefix + 'DATA.UPDATE.STATUS'])
                        .subscribe((response: Object) => this.notificationService.basicNoty('ERROR', response[this.prefix + 'DATA.UPDATE.STATUS'], response[this.prefix + 'LABEL']));
                    return Promise.reject(error);
                });
        })());
    }

    getInitial(): Promise<any> {
        return Promise.resolve((() => {
            return this.requestService.postData('api/productInitList', {}, 'post')
                .toPromise()
                .catch((error: HttpErrorResponse | any) => {
                    this.translate.get([this.prefix + 'LABEL', this.prefix + 'DATA.FETCH.INITIAL'])
                        .subscribe((response: Object) => this.notificationService.basicNoty('ERROR', response[this.prefix + 'DATA.FETCH.INITIAL'], response[this.prefix + 'LABEL']));
                    return Promise.reject(error);
                });
        })());
    }

    getVariants(): Promise<any> {
        return Promise.resolve((() => {
            return this.requestService.postData('api/variants/product', {}, 'post')
                .toPromise()
                .catch((error: HttpErrorResponse | any) => {
                    this.translate.get([this.prefix + 'LABEL', this.prefix + 'DATA.FETCH.INITIAL'])
                        .subscribe((response: Object) => this.notificationService.basicNoty('ERROR', response[this.prefix + 'DATA.FETCH.INITIAL'], response[this.prefix + 'LABEL']));
                    return Promise.reject(error);
                });
        })());
    }
}
